import { css } from 'lit';
import componentStyles from '../../styles/component.styles.js';
export default css `
    ${componentStyles}
    :host {
        display: flex;
        box-sizing: border-box;
    }

    /* Theme variation */
    :host([theme~='margin']) {
        margin: 1em;
    }

    :host([theme~='padding']) {
        padding: 1em;
    }

    :host([theme~='spacing']) {
        gap: 1em;
    }
`;
//# sourceMappingURL=horizontal-layout.styles.js.map